import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import InsertRowAboveOutlinedSvg from "@ant-design/icons-svg/es/asn/InsertRowAboveOutlined";
import AntdIcon from "../components/AntdIcon";
var InsertRowAboveOutlined = function InsertRowAboveOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InsertRowAboveOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  InsertRowAboveOutlined.displayName = 'InsertRowAboveOutlined';
}
export default /*#__PURE__*/React.forwardRef(InsertRowAboveOutlined);